module.exports = "/_next/static/images/CertHub-407304abde17e867a7e5df83f7f3c9fc.svg";